module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/resultsinterpretation/resultsinterpretation.component.css
// module id = ./src/app/resultsinterpretation/resultsinterpretation.component.css
// module chunks = main